/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartRemoveItemVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
  itemIndex: Types.Scalars['Int']
}>

export type CartRemoveItem = {
  __typename: 'Root'
  cartRemoveItem: {
    __typename: 'CartRemoveItemPayload'
    cart: { __typename: 'Cart'; id: number | null; uuid: string | null } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartRemoveItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartRemoveItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'itemIndex' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartRemoveItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemIndex' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'itemIndex' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CartRemoveItemMutationFn = Apollo.MutationFunction<
  CartRemoveItem,
  CartRemoveItemVariables
>

/**
 * __useCartRemoveItem__
 *
 * To run a mutation, you first call `useCartRemoveItem` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartRemoveItem` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartRemoveItem, { data, loading, error }] = useCartRemoveItem({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *      itemIndex: // value for 'itemIndex'
 *   },
 * });
 */
export function useCartRemoveItem(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartRemoveItem,
    CartRemoveItemVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CartRemoveItem, CartRemoveItemVariables>(
    CartRemoveItemDocument,
    options
  )
}
export type CartRemoveItemHookResult = ReturnType<typeof useCartRemoveItem>
export type CartRemoveItemMutationResult = Apollo.MutationResult<CartRemoveItem>
export type CartRemoveItemMutationOptions = Apollo.BaseMutationOptions<
  CartRemoveItem,
  CartRemoveItemVariables
>
